<template>
    <div class="container-fluid">
        <b-table
            class="is-size-7"
            :data="eventList.slice(0, rows)"
            :striped="striped"
            :bordered="bordered"
            :default-sort="defaultSort"
            :default-sort-direction="defaultSortDirection"
            :narrowed="narrowed"
        >
            <b-table-column
                :centered="centered"
                :sortable="sortable"
                field="type"
                label="Type"
                v-slot="props"
            >{{ props.row.type }}</b-table-column>
            <b-table-column
                field="timestamp"
                label="Time"
                :centered="centered"
                :sortable="sortable"
                v-slot="props"
            >{{ props.row.timestamp }}</b-table-column>
            <b-table-column v-if="showDelete" label="Remove" v-slot="props" :centered="centered" width="40">
                <b-button :icon-pack="pack" type="is-danger" icon-left="trash" @click="removeRow(props.row)"></b-button>
            </b-table-column>
        </b-table>
    </div>
</template>

<script>
import deleteLog from '../helpers/fireBaseDelete'
import db from '../fireBaseInit'

export default {
    props: ['eventList', 'rows','showDelete'],
    data() {
        return {
            eventType: [
                { name: 'Feed', 'icon': '&#127868' },
                { name: 'Solid', 'icon': '&#128169' },
                { name: 'Liquid', 'icon': '&#128701' }
            ],
            centered: true,
            sortable: true,
            striped: true,
            bordered: true,
            defaultSort: "timestamp",
            defaultSortDirection: "desc",
            narrowed: true,
            pack: "fa"
        }
    },
    methods: {
        removeRow(row) {
            deleteLog(db, row.id)
            this.$emit('remove-row', this.eventList.filter(doc => doc.id != row.id))
        }
    }
}
</script>

<style>
.delete {
    background-color: red !important;
}
</style>